import React from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

// Lista de países (reducida del ejemplo para brevedad, puedes ampliarla)
export const paises = [
  { id: 1, nombre: "España" },
  { id: 2, nombre: "Alemania" },
  { id: 3, nombre: "PORTUGAL" },
  { id: 5, nombre: "MEXICO" },
  { id: 7, nombre: "RUMANIA" },
  { id: 11, nombre: "AUSTRALIA" },
  { id: 12, nombre: "FRANCIA" },
  { id: 13, nombre: "RUMANIA" },
  { id: 14, nombre: "PERU" },
  { id: 16, nombre: "PORTUGAL" },
  { id: 17, nombre: "BULGARIA" },
  { id: 20, nombre: "COLOMBIA" },
  { id: 21, nombre: "CUBA" },
  { id: 22, nombre: "VENEZUELA" },
  { id: 23, nombre: "ITALIA" },
  { id: 25, nombre: "COSTA RICA" },
  { id: 27, nombre: "REPUBLICA DOMINICANA" },
  { id: 28, nombre: "BOLIVIA" },
  { id: 29, nombre: "ALEMANIA" },
  { id: 30, nombre: "PERU" },
  { id: 31, nombre: "PERU" },
  { id: 33, nombre: "HONDURAS" },
  { id: 34, nombre: "FRANCIA" },
  { id: 35, nombre: "RUSIA" }
];

const SelectPais = ({ name, label, value, onChange, error, helperText }) => {
  return (
    <FormControl fullWidth error={!!error}>
      <InputLabel id={`${name}-label`}>{label}</InputLabel>
      <Select
        labelId={`${name}-label`}
        id={`${name}-select`}
        name={name}
        value={value || ""}
        label={label}
        onChange={onChange}
      >
        <MenuItem value="">
          <em>Seleccione una opción</em>
        </MenuItem>
        {paises.map((pais) => (
          <MenuItem key={pais.id} value={pais.id}>
            {pais.nombre}
          </MenuItem>
        ))}
      </Select>
      {helperText && (
        <p style={{ color: "#d32f2f", fontSize: "0.75rem", margin: "3px 14px 0" }}>
          {helperText}
        </p>
      )}
    </FormControl>
  );
};

export default SelectPais;
